<template>
  <a-collapse style="margin-bottom:24px" :default-active-key="['special-invoice']">
    <a-collapse-panel key="special-invoice" header="专用发票温馨提示">
      <a-spin :spinning="loading">
        <a-form layout="inline">
          <a-form-item label="专票加收比例">
            <a-input-number v-model="rate" :min="0" :max="100" :precision="2" /> %
          </a-form-item>
          <a-button type="primary" v-hasPermi="['config:config:edit']" :loading="saving" :disabled="!loaded" @click="save">保存</a-button>
        </a-form>
        <p style="margin-top:16px">提示预览：开专用发票，会额外加收{{ rate }}%的费用，如有疑问，请联系客服。</p>
        <p style="color:#8c8c8c">商城端、客服端提示与专票费用使用同一比例。修改后重新打开发票选择窗口查看最新提示。</p>
      </a-spin>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import request from '@/utils/request'
const url = '/dkmall/content-settings/special-invoice'
export default {
  name: 'SpecialInvoiceConfiguration',
  data: () => ({ rate: null, loading: false, saving: false, loaded: false }),
  created () {
    this.loading = true
    request({ url, method: 'get' }).then(r => { this.rate = Number((r.data || {}).rate); this.loaded = true }).finally(() => { this.loading = false })
  },
  methods: {
    save () {
      if (this.rate === null || !Number.isFinite(this.rate) || this.rate < 0 || this.rate > 100) return this.$message.warning('请填写 0～100 的比例')
      this.saving = true
      request({ url, method: 'put', data: { rate: String(this.rate) } }).then(() => this.$message.success('专用发票提示比例已保存')).finally(() => { this.saving = false })
    }
  }
}
</script>
